export const activitySettings = {
  title: 'Paramètres de l\'activité',
  
  // Informations du commerce
  businessInfo: {
    title: 'Informations du commerce',
    businessId: 'Identifiant du commerce',
    businessName: 'Nom du commerce'
  },

  // Logo
  logo: {
    title: 'Logo',
    preview: 'Aperçu du logo',
    upload: 'Télécharger un logo',
    requirements: 'Spécifications du logo'
  },

  // Paramètres généraux
  generalSettings: {
    title: 'Paramètres généraux',
    currency: {
      label: 'Devise',
      options: {
        EUR: 'Euro (€)',
        USD: 'Dollar américain ($)',
        MAD: 'Dirham marocain (د.م.)'
      }
    },
    language: {
      label: 'Langue par défaut',
      options: {
        fr: 'Français',
        ar: 'العربية',
        es: 'Español'
      }
    }
  },

  // Numérotation des tickets
  ticketNumbering: {
    title: 'Numérotation des tickets',
    type: {
      label: 'Type de numérotation',
      options: {
        daily: 'Quotidienne',
        monthly: 'Mensuelle',
        yearly: 'Annuelle',
        continuous: 'Continue'
      }
    },
    prefix: {
      label: 'Préfixe',
      placeholder: 'Ex: TKT-'
    },
    suffix: {
      label: 'Suffixe',
      placeholder: 'Ex: -2024'
    },
    startNumber: {
      label: 'Numéro de départ'
    }
  },

  // Sauvegardes
  backup: {
    title: 'Sauvegardes',
    create: {
      title: 'Créer une sauvegarde',
      description: 'Créez une sauvegarde complète de votre base de données. Le fichier sera téléchargé sur votre ordinateur.',
      button: 'Créer une sauvegarde',
      saving: 'Création de la sauvegarde...'
    },
    restore: {
      title: 'Restaurer une sauvegarde',
      description: 'Sélectionnez un fichier de sauvegarde pour restaurer votre base de données à un état précédent.',
      button: 'Sélectionner un fichier'
    },
    history: {
      title: 'Historique des sauvegardes',
      filename: 'Nom du fichier',
      date: 'Date',
      size: 'Taille'
    }
  },

  // Messages
  messages: {
    saveSuccess: 'Paramètres sauvegardés avec succès',
    saveError: 'Erreur lors de la sauvegarde des paramètres',
    loadError: 'Erreur lors du chargement des paramètres',
    backupSuccess: 'Sauvegarde créée avec succès',
    backupError: 'Erreur lors de la création de la sauvegarde',
    restoreSuccess: 'Base de données restaurée avec succès',
    restoreError: 'Erreur lors de la restauration de la base de données',
    saving: 'Sauvegarde en cours...',
    save: 'Enregistrer'
  }
}; 